// extracted by mini-css-extract-plugin
module.exports = {"gift":"nN","giftOptionsButton":"oN","changeButton":"pN"};